import { AfterContentInit, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { NgClass, SlicePipe } from '@angular/common';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';

@Component({
    selector: 'app-detalle-tabla-servicios-siniestro-resumen',
    templateUrl: './detalle-tabla-servicios-siniestro-resumen.component.html',
    styleUrls: ['./detalle-tabla-servicios-siniestro-resumen.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, SlicePipe]
})
export class DetalleTablaServiciosSiniestroResumenComponent implements AfterContentInit {

  @ViewChild('asegurado') paginatorA: MatPaginator;
  @ViewChild('tercero') paginatorT: MatPaginator;

  @Input() public datosAsegurado: MatTableDataSource<any> = new MatTableDataSource([]);

  @Input() public datosTerceros: MatTableDataSource<any> = new MatTableDataSource([]);

  public tamanoResultadosAsegurados: number = 0;
  public selectCoberturasDatosAsegurados = null;
  public selectedCoberturaRowIndexAsegurados: number = null;

  public tamanoResultadosTerceros: number = 0;
  public selectCoberturasDatosTerceros = null;
  public selectedCoberturaRowIndexTerceros: number = null;

  public displayColumns = ['Servicio', 'Proveedor', 'Reporte'];

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };
  public paginatorInfoTer = { pageStart: 0, pageEnd: 0 };

  constructor() {

  }

  ngAfterContentInit(): void {
  }

  SelectRow(row, tipo: 'ASEGURADO' | 'TERCEROS') {
    if (tipo === 'ASEGURADO') {
      this.selectCoberturasDatosAsegurados = row.id;
      this.selectedCoberturaRowIndexAsegurados = row;
    } else {
      this.selectedCoberturaRowIndexTerceros = row.id;
      this.selectCoberturasDatosTerceros = row
    }
  }
}
